import {Injectable} from '@angular/core';
import {Apollo} from "apollo-angular";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {gql} from "@apollo/client/core";
import {IServicePaginate} from "../@types/service-paginate";
import {IServiceGetOne} from "../@types/service-get-one";
import {PropertySubType} from "../models";
import {BaseService} from "./base-service.service";

@Injectable({
  providedIn: 'root'
})
export class PropertySubTypeService extends BaseService implements IServicePaginate<PropertySubType>, IServiceGetOne<PropertySubType> {

  constructor(private apollo: Apollo) {
    super();
  }

  defaultSearchWhere(term: string): string {
    return `where: { column: NAME, operator: LIKE, value: "${term}%"}`;
  }

  public getAll(): Observable<PropertySubType[]> {
    return this.apollo.watchQuery({
      query: PropertySubTypeService.getAllQuery()
    }).valueChanges.pipe(
      map((result: any) => result.data && result.data.PropertySubTypes),
      map((result: any) => result ?? [])
    );
  }

  public paginate(page: number = 1, perPage: number = 10, where: string): Observable<PropertySubType[]> {
    return this.apollo.watchQuery({
      query: this.paginateQuery(page, perPage, where)
    }).valueChanges.pipe(
      map((result: any) => result.data && result.data.PropertySubTypePaginate && result.data.PropertySubTypePaginate.data),
      map((result: any) => result ?? [])
    );
  }

  public getOne(column: string, value: any): Observable<PropertySubType | undefined> {
    return this.apollo.watchQuery({
      query: this.getOneQuery(column, value)
    }).valueChanges.pipe(
      map((result: any) => result.data && result.data.PropertySubTypePaginate && result.data.PropertySubTypePaginate.data && result.data.PropertySubTypePaginate.data[0])
    );
  }

  /**
   * GraphQL Queries
   * */
  static getAllFields() {
    return `
      id,
      name,
      description,
      form,
      enable
      propertyType {
        id,
        name
      }
    `
  }

  private paginateQuery(page: number = 1, perPage: number = 10, where: string) {
    return gql`{
      PropertySubTypePaginate(
        page: ${page},
        first: ${perPage},
        ${where}
      ) {
        data {${PropertySubTypeService.getAllFields()}}
      }
    }`
  }


  static getAllQuery() {
    return gql`{ PropertySubTypes {  ${PropertySubTypeService.getAllFields()} } }`;
  }

  static getAllQueryRow() {
    return  'PropertySubTypes {' +  PropertySubTypeService.getAllFields() + '}';
  }

  private getOneQuery(column: string, value: any) {
    const normalizedValue = typeof value === 'string' ? `"${value}"` : value;

    return gql`{
      PropertySubTypePaginate(
        page: 1,
        first: 1,
        where:{ column: ${column.toUpperCase()}, value: ${normalizedValue} }
      ) {
        data {${PropertySubTypeService.getAllFields()}}
      }
    }`;
  }
}
